import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { ReactNode } from 'react';

import { TradFiCategory, getAvailableTradFiCategories } from '@flipster/features/src/shared/rwa';
import { FormattedMessage } from '@flipster/i18n';
import { createSingleChoice } from '@flipster/react/design-system/chip';

import { marketPageBunja, marketSymbolBunja } from '../state';

const Choice = createSingleChoice<TradFiCategory>();

const categoryLabels: Record<TradFiCategory, ReactNode> = {
  all: <FormattedMessage id='Autogen_common.r251126.s_All' />,
  preIpo: <FormattedMessage id='Market.r260624.Preipo' />,
  etf: <FormattedMessage id='Market.r260624.Etf' />,
  stock: <FormattedMessage id='Market.r260624.Stock' />,
  commodity: <FormattedMessage id='Market.r260624.Commodity' />,
};

export const DiscoverTradFiCategoryChips = () => {
  const { discoverTradfiCategoryAtom, setDiscoverTradfiCategory } = useBunja(marketPageBunja);
  const category = useAtomValue(discoverTradfiCategoryAtom);
  const { symbolsByMarketTabAtom } = useBunja(marketSymbolBunja);
  const symbols = useAtomValue(symbolsByMarketTabAtom);
  const categories = getAvailableTradFiCategories(symbols);

  return (
    <Choice
      value={category}
      onChange={setDiscoverTradfiCategory}
      css={{ overflowX: 'auto', padding: { base: '16px 16px 0', tablet: '16px 0 0' } }}
    >
      {categories.map((value) => (
        <Choice.Chip key={value} value={value} label={categoryLabels[value]} />
      ))}
    </Choice>
  );
};
